import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient"

export const addResponse = async (question_id: string, content: string, field_value: string | null, user_id: string) => await supabase.from('response').insert({ question_id, content, field_value, user_id }).select()

export const deleteInvalidatedResponses = async (question_id: Tables<'question'>['id'], userId: Tables<'user'>['id']) => {
    if (!question_id) return;
    const res = await supabase.from('response').delete().eq('question_id', question_id).eq('user_id', userId).select();
    return res;
}